import ActionModal from "components/blocks/Modal/ActionModal";
import { useCookieContext } from "contexts";
import useMutation from "hooks/useMutation";
import { Dispatch, SetStateAction, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ExaminersService } from "services/examinersService";
import { ExaminerOrderEvaluationFormResult } from "services/examinersService/Model/ExaminerTypes";
import {RefereesService} from "../../../../../services/RefereeService";
import {RefereeOrderEvaluationFormResult} from "../../../../../services/RefereeService/Model/RefereeTypes";


type AcceptButtonProps = {
  t: any;
  examinerProgramOrderId: number;
  setData: Dispatch<SetStateAction<RefereeOrderEvaluationFormResult | null>>;
};

const AcceptButton = ({ t, examinerProgramOrderId, setData }: AcceptButtonProps) => {
  const navigate = useNavigate();
  const { userSession } = useCookieContext();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const { loading, mutateAsync, reset } = useMutation({
    queryFn: async (examinerProgramOrderId: number) => {
      return await RefereesService.acceptRefereeOrderEvaluationForm(examinerProgramOrderId);
    },
  });

  const accept = async () => {
    const res = await mutateAsync(examinerProgramOrderId);
    if (!!res?.hasError) {
      setIsModalOpen(!!res?.hasError);
      return;
    }

    setData((old) => {
      console.log(old, "old")
      if (old)
        return {...old, refereeStatus: "Accepted"}
      else return old;

    })
  }
  

  return (
    <>
      {loading ? (
        <div className="custom-loader"></div>
      ) : (
        <button type="button" className="btn btn-primary px-4" onClick={accept}>
          {t("accept")}
        </button>
      )}
      <ActionModal
        isOpen={isModalOpen}
        iconWrapperColor="warning"
        actionIcon="icon-warning-circle"
        headerMsg={t("bankingInformationNotCompleted")}
        subMsg={t("bankingInformationNotCompletedMsg")}
        confirmBtnText={t("goToProfile")}
        loading={loading}
        onActionConfirm={() => {
          navigate(`/home/editUserProfile/${userSession!.id}`);
        }}
        onClose={() => {
          reset();
          setIsModalOpen(false);
        }}
      />
    </>
  );
};

export default AcceptButton
